import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={10}
      height={10}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G clipPath="url(#clip0_9097_3622)">
        <Path
          d="M5 0C3.76 0 2.575.463 1.667 1.274V0H.833v2.083c0 .46.374.834.834.834H3.75v-.834H2.025A4.174 4.174 0 015 .833 4.171 4.171 0 019.167 5 4.171 4.171 0 015 9.167 4.171 4.171 0 01.833 5H0c0 2.757 2.243 5 5 5s5-2.243 5-5-2.243-5-5-5z"
          fill="#000"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_9097_3622">
          <Path fill="#fff" d="M0 0H10V10H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  );
}

export default SvgComponent;
